import Vue from 'vue'

const state = {
	workType: "",  //当前的任务类型
	userInfo:"",  //当前选中的用户
	userInfoDetail:'',  //用户信息详情，也就是聊天框上方的东西，留个坑位，以后用户服务期会在这里面找
	traySelectUserInfo:'',  //点击托盘后要选中的用户信息
	
	
	tabType:"",  //用户表现的类型
	date:"",//当前日期，表示当前客户端是选中哪个日期，黄耿智：2022-08-01
	globalTabType:"",  //左侧导航栏的标签类型
	windowsIdArr:[],  //创建窗口的id
	widowsWidht:"",  //屏幕宽度
	widowsHeight:"",  //屏幕高度
	WeChat:{},
}

const mutations = {
	setWidowSize(state,{width,height}){
		state.widowsWidht = width;
		state.widowsHeight = height;
	},
	setWorkType(state, workType) {
		state.workType = workType;
	},
	setUserInfo(state, userInfo) {
		state.userInfo = userInfo;
	},
	setUserInfoDetail(state,userInfoDetail){
		state.userInfoDetail = userInfoDetail
	},
	setTraySelectUserInfo(state,traySelectUserInfo){
		state.traySelectUserInfo = traySelectUserInfo
	},
	//设置当前日期，表示当主要信息加载的是哪天的信息，黄耿智：2022-08-01
	setDate(state, date) {
		state.date = date;
	},
	setTabType(state,tabType){
		state.tabType = tabType;
	},
	setGlobalTabType(state,globalTabType){
		state.globalTabType = globalTabType;
	},
	setWindowsId(state,windowsId){
		if(state.windowsIdArr.indexOf(windowsId) == -1){
			state.windowsIdArr.push(windowsId);
		}
	},
	
	delWindowsId(state,windowsId){
		let index = state.windowsIdArr.findIndex((item, index) => {
			return item == windowsId
		});
		if(index != -1){
			state.windowsIdArr.splice(index,1);
		}
	},
	// setWeChat(state,data){
	// 	state.WeChat = data;
	// 	// Vue.prototype.$WeChat = data
	// 	console.log(Vue.prototype.$WeChat,"Vue.prototype")
	// },
}

const actions = {
	setWeChat({commit},data) {
		// do something async
		commit('setWeChat',data)
	},
	setWidowSize({commit},data) {
		// do something async
		commit('setWidowSize',data)
	},
	setWorkType({commit},data) {
		// do something async
		commit('setWorkType',data)
	},
	setUserInfo({commit},data) {
		// do something async
		commit('setUserInfo',data)
	},
	setUserInfoDetail({commit},data){
		commit('setUserInfoDetail',data)
	},
	setTabType({commit},data) {
		// do something async
		commit('setTabType',data)
	},
	setGlobalTabType({commit},data) {
		// do something async
		commit('setGlobalTabType',data)
	},
	setWindowsId({commit},data) {
		// do something async
		commit('setWindowsId',data)
	},
	delWindowsId({commit},data) {
		// do something async
		commit('delWindowsId',data)
	},
}

export default {
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js